// The department a lab test belongs to.
//
// It is the service master's classification, carried on the order as
// classification_name (or legacy service_classification_name) and mapped to
// `department` by mapApiOrder in labOrdersShared.js.
//
// An order placed before the classification was recorded (or against a service
// that has none) has no department. Those are collected under one bucket rather
// than guessed at: a requisition sent to the wrong bench is worse than one the
// lab has to route by hand.

export const UNCLASSIFIED = "Unclassified";

/** Department for one board order (labOrdersShared mapApiOrder shape). */
export function resolveLabDepartment(order) {
  const name = String(order?.department ?? "").trim();
  return name && name !== "-" ? name : UNCLASSIFIED;
}

/**
 * Departments present in a set of orders, each with its test count, ordered
 * the way the chips read best: named departments A–Z, Unclassified last.
 */
export function departmentCounts(orders) {
  const counts = new Map();
  (orders || []).forEach((o) => {
    const dept = resolveLabDepartment(o);
    counts.set(dept, (counts.get(dept) || 0) + 1);
  });
  return Array.from(counts.entries())
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => {
      if (a.name === UNCLASSIFIED) return 1;
      if (b.name === UNCLASSIFIED) return -1;
      return a.name.localeCompare(b.name);
    });
}
